//import Vue from 'vue'
import dragDialog from './dragDialog.js'
import xScroll from './xScroll.js'
import floatDrag from './dragFloat.js'
import shiftMultiSelect from './shiftMultiSelect.js'
import CheckfloatDrag from './dragCheckFloat.js'
export const directiveInstall = {
    list:{
        dialogDrag:dragDialog,
        xScroll:xScroll,
        floatDrag:floatDrag,
        shiftMultiSelect:shiftMultiSelect,
        CheckfloatDrag:CheckfloatDrag
    },
    install(Vue){
        if(typeof window !== 'undefined' && window.Vue) {
            Vue = window.Vue
        }
        for(let key in this.list){
            Vue.directive(key,this.list[key])
        }
    }
}
